import React from 'react'
import { Route, Redirect, RouteProps } from 'react-router-dom';
import AuthContext from './AuthContext'

export interface IPrivateRouteProps extends RouteProps {
  redirectPath: string // redirect path if don't authenticate route
}
const PrivateRoute: React.FC<IPrivateRouteProps> = (props) => {
  const auth = React.useContext(AuthContext);

  return auth.state.isAuthenticated ? (
    <Route {...props} component={props.component} render={undefined} />
  ) : (
    <Redirect to={{ pathname: props.redirectPath }} />
  )

};

export default PrivateRoute;

